import {SWITCH_LANGUAGE, INDUSTRY_ASSET, SOURCE_ASSET, CLIENT_EVENTS_ASSET, LEAD_STATUS_ASSET, SERVICE_TYPE_ASSET } from "../../constants/ActionTypes";
import {
  LAYOUT_TYPE,
  LAYOUT_TYPE_FULL,
  NAV_STYLE, NAV_STYLE_DEFAULT_HORIZONTAL, NAV_STYLE_DRAWER,
  NAV_STYLE_FIXED,
  THEME_COLOR,
  THEME_TYPE,
  THEME_TYPE_SEMI_DARK
} from "../../constants/ThemeSetting";

const initialSettings = {
  navStyle: NAV_STYLE_DRAWER,
  layoutType: LAYOUT_TYPE_FULL,
  themeType: THEME_TYPE_SEMI_DARK,
  themeColor: THEME_COLOR,
  sources: SOURCE_ASSET,

  isDirectionRTL: false,
  locale: {
    languageId: 'english',
    locale: 'en',
    name: 'English',
    icon: 'us'
  }
};

const settings = (state = initialSettings, action) => {
  switch (action.type) {

    case THEME_TYPE:
      return {
        ...state,
        themeType: action.themeType
      };
    case THEME_COLOR:
      console.log("yes",action.themeColor);
      return {
        ...state,
        themeColor: action.themeColor
      };

    case NAV_STYLE:
      return {
        ...state,
        navStyle: action.navStyle
      };
    case LAYOUT_TYPE:
      return {
        ...state,
        layoutType: action.layoutType
      };

    case SWITCH_LANGUAGE:
      return {
        ...state,
        locale: action.payload,

      };
    case INDUSTRY_ASSET:
      return {
        ...state,
        industries: action.industries,

      };
    case SOURCE_ASSET:
      return {
        ...state,
        sources: action.sources,

      };
    case CLIENT_EVENTS_ASSET:
      return {
        ...state,
        clientEvents: action.clientEvents,

      };
    case LEAD_STATUS_ASSET:
      return {
        ...state,
        leadStatusses: action.leadStatusses,

      };
    case SERVICE_TYPE_ASSET:
      return {
        ...state,
        serviceTypes: action.serviceTypes,

      };
    default:
      return state;
  }
};

export default settings;
